import api from '@/api';
import { normalize } from './normalize';
import { batch } from 'react-redux';

/*
    TODO: errors / namings / fetching

    Может быть разделить данные на две модели?
*/

/*
    https://redux.js.org/usage/structuring-reducers/normalizing-state-shape
*/

const filterNeighborDuplicates = arr => {
    return arr.map(item => {
        const { data, ...rest } = item;

        const cleanX = data?.dx && data.dx.filter((v, i, arr) => i === 0 || v !== arr[i - 1]);
        const cleanY = data?.dy && data.dy.filter((v, i, arr) => i === 0 || v !== arr[i - 1]);
        const cleanZ = data?.z && data.z.filter((v, i, arr) => i === 0 || v !== arr[i - 1]);
        const cleanMd = data?.md && data.md.filter((v, i, arr) => i === 0 || v !== arr[i - 1]);

        return { ...rest, data: { ...data, dx: cleanX, dy: cleanY, z: cleanZ, md: cleanMd } };
    });
};

const initialState = {
    versions: [],
    details: {},
    /*
        мы можем получить абсолютную глубину только из инклинометрии
        т.к. сейчас логика не позволяет загружать много details, то данные значения будут храниться в поле absDepthByWellId

        В идеальности текущее поле вынести в данные для таблета и избежать двойных запросов инклинометрии
    */
    absDepthByWellId: {},
    detailsByWellId: {},

    activeVersionID: null,
    isLoading: false,
    hasError: false,
};

export const inclinometry = {
    state: initialState,
    reducers: {
        setInclinometry(state, payload) {
            return { ...state, details: payload.details, versions: payload.versions };
        },
        setAbsDepthByWellId(state, payload) {
            return {
                ...state,
                absDepthByWellId: {
                    ...state.absDepthByWellId,
                    [payload.wellId]: payload.data,
                },
            };
        },
        setDetailsByWellId(state, payload) {
            return {
                ...state,
                detailsByWellId: {
                    ...state.detailsByWellId,
                    [payload.wellId]: payload.data,
                },
            };
        },
        setActiveVersionID(state, payload) {
            return { ...state, activeVersionID: payload };
        },
        reset(state) {
            return {
                ...initialState,
                absDepthByWellId: state.absDepthByWellId,
                detailsByWellId: state.detailsByWellId,
            };
        },
        setIsLoading(state, payload) {
            return { ...state, isLoading: payload };
        },
        setHasError(state, payload) {
            return { ...state, hasError: payload };
        },
        setRequestStatus(state, payload) {
            return { ...state, ...payload };
        },
    },
    effects: {
        async getInclinometry(wellId) {
            this.setRequestStatus({ isLoading: true });

            try {
                const response = await api.inclinometry.get(wellId);
                const result = await response.json();

                const filteredResult = filterNeighborDuplicates(result);

                // const result = await api.inclinometry.get(wellID);

                /*
                    Оптимизировать запуск при получении пустой коллекции
                    if (Array.isArray(result) && isEmpty(result)) return;
                 */

                // Для тестирования ошибки
                // const res = result.map(it => ({ ...it, data: { error: { code: 500 } } }));

                /*
                    Используется базовая нормализация. Ее можно обновлять и дополнять, исходя
                    из новых требований к данным
                */

                // normalizeData -> lastVersionID
                //getAbsDepthFromInclinometry

                await this.getAbsDepthFromInclinometry({ result: filteredResult, wellId: wellId });
                const normalizeData = normalize.formatBase(filteredResult);

                batch(() => {
                    this.setInclinometry(normalizeData);
                    this.setActiveVersionID(normalizeData.lastVersionID);

                    this.setRequestStatus({ isLoading: false });
                });
            } catch (error) {
                this.setRequestStatus({ isLoading: false, hasError: true });
            }
        },

        /*
            TODO: дубликат для загрузки абсолютной глубины;
            В идеальности переписать на api.inclinometry.getMany
        */
        async getAbsDepthFromInclinometry(payload, rootState) {
            const { result, wellId } = payload;

            try {
                if (result && Object.keys(result).length > 0) {
                    const { UWI } = result;

                    const { rel, abs, data } = normalize.toAbsDepth(result);

                    this.setAbsDepthByWellId({ wellId, data });
                    this.setDetailsByWellId({ wellId, data: { rel, abs, UWI } });
                }
            } catch (error) {
                console.error('getAbsDepthFromInclinometry', error);
            }
        },
    },
    selectors: slice => ({
        getActiveVersion() {
            return slice(model => {
                const { versions, activeVersionID } = model;

                if (!activeVersionID) return null;
                return versions.find(item => item.inclinometryId === activeVersionID);
            });
        },
        getDetailsOfActiveVersion() {
            return slice(model => {
                const { details, activeVersionID } = model;

                return details[activeVersionID];
            });
        },
    }),
};
